import type { RootState } from '..';
import { createStringContentSlice } from './helpers/slice_helpers';

const skillCommentSlice = createStringContentSlice({ name: 'skillComment' });

export const { setContent: updateSkillComment } = skillCommentSlice.actions;

export const selectSkillComment = (state: RootState) => state.skillComment.content;

export default skillCommentSlice.reducer;
